import { render, staticRenderFns } from "./CreateSuggestion.vue?vue&type=template&id=efda62e0&scoped=true&"
import script from "./CreateSuggestion.vue?vue&type=script&lang=js&"
export * from "./CreateSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efda62e0",
  null
  
)

export default component.exports